import { notification } from 'antd';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFundingSources } from '../services/AccountApi/paymentMethodApi';
import { resetLoginPin } from '../services/AccountApi/profileApi';
import { getAccountBalances, getAgreement, placeBuyOrder, processPlaceOrder, balanceBank } from '../services/InitialOfferings/initialOfferingSection';
import { cancelBuyOrderAction, fetchInitialOfferingListAction } from '../store/reducer/initialOfferingSlice';
import { fetchSecondaryOfferingListAction } from '../store/reducer/secondaryOfferingSlice';
import { toastNotify } from '../utils/toastNotify';
import { getUsPercentageFormat } from '../utils/usCurrencyFormatter';

import ListingAgreementNotification from '../components/ListingAgreement/ListingAgreementNotification';
import { primaryBuy } from '../constants/PrimaryBuy';
import { BonusAmount, ERROR_BALANCE_BANK_MESSAGE, ENTITY_MINIMUM_INITIAL_INVESTMENT } from '../utils/constant';
import { ACCOUNT_TYPES } from '../constants/accountType.constants';

const useQuickBuyOrder = (modalState, quickBuyPropertyData) => {
  const [loading, setLoading] = useState(false);
  const [pin, setPin] = useState('');
  const [isPinVerified, SetIsPinVerified] = useState(false);

  const [walletsData, setWalletsData] = useState([]);
  const [numberOfShare, setNumberOfShare] = useState('');
  const [resetPin, setResetPin] = useState(false);
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [agreementData, setAgreementData] = useState('');
  const [orderId, setOrderId] = useState('');
  const [isScrolledBuy, setIsScrolledBuy] = useState(false);
  const [isTurmAndCondistion, setIsTurmAndCondistion] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});
  const [isEditPayment, setIsEditPayment] = useState(false);
  const [userBalance, setUserBalance] = useState();

  const [isTOSModal, setIsTOSModal] = useState(false);
  const userData = useSelector((state) => state.userData.userData);
  const referralBonusShares = BonusAmount.REFERRAL_BONUS_AMOUNT / quickBuyPropertyData?.perSharePrice
  /**
   * @type {boolean}
   */
  const bankExists = useMemo(() => userData.isBankExist, [userData.isBankExist]);
  /**
   * @type {boolean}
   */
  const bankVerified = useMemo(() => !userData.isUnverifiedBank, [userData.isUnverifiedBank]);
  const dispatch = useDispatch();
  const totalInvestment = Number(quickBuyPropertyData?.perSharePrice) * Number(numberOfShare);
  const totalPurchase = totalInvestment + 2.5;
  const equity = getUsPercentageFormat((Number(numberOfShare) / Number(quickBuyPropertyData?.totalShares)) * 100);
  const equityWithBonusShares = getUsPercentageFormat(((Number(referralBonusShares) + Number(numberOfShare)) / Number(quickBuyPropertyData?.totalShares)) * 100)
  let date1 = moment();
  let date2 = moment(new Date(quickBuyPropertyData?.duration));
  let daysReamaining = date2.diff(date1, 'days');
  const remainingSharesCount = (Number(quickBuyPropertyData?.totalShares) * 9.8) / 100 - Number(quickBuyPropertyData?.userPurchasedShares);
  const remainingShares = Math.floor(remainingSharesCount.toFixed(2));
  const isMaxRangeError = Number(numberOfShare) > Number(remainingShares);
  const isEntityAccount = userData?.accountType === ACCOUNT_TYPES.ENTITY;
  // isFirstOrder comes from the validate-pin API response (same flag QuickBuyInitial.js/
  // QuickBuyInitialDrawer.js already use to decide whether to show the Referral Code field).
  const isFirstInvestment = !!userData?.isFirstOrder;
  // Entity/Trust accounts must invest exactly $1,000 minimum on their initial (first-ever)
  // order — this frontend-set floor replaces the backend's per-property minimum outright
  // for that one order; later orders fall back to whatever minimum the backend sends (RDS-967).
  const minimumInvestment =
    isEntityAccount && isFirstInvestment ? ENTITY_MINIMUM_INITIAL_INVESTMENT : Number(quickBuyPropertyData?.minimum);
  const capDerivedMinButtonValue =
    minimumInvestment / Number(quickBuyPropertyData?.perSharePrice) === Infinity
      ? 0
      : remainingShares < minimumInvestment / Number(quickBuyPropertyData?.perSharePrice)
      ? Math.floor(((Number(quickBuyPropertyData?.totalShares) * 9.8) / 100 - Number(quickBuyPropertyData?.userPurchasedShares)).toFixed(2))
      : Math.ceil(minimumInvestment / Number(quickBuyPropertyData?.perSharePrice));
  const actualSharesRemaining = Number(quickBuyPropertyData?.sharesRemaining);
  // When actual property inventory is below the 9.8%-cap/$-minimum-derived floor, that floor
  // isn't actually purchasable — let the user buy whatever's left instead (same low-inventory
  // fallback already used for the $1,000 minimum scenario), otherwise no valid share count
  // exists (the floor gets rejected as exceeding availability, and availability gets rejected
  // as below the floor).
  const minButtonValue =
    Number.isFinite(actualSharesRemaining) && actualSharesRemaining < capDerivedMinButtonValue
      ? Math.max(actualSharesRemaining, 0)
      : capDerivedMinButtonValue;
  const rawSuggestedButtonValue = Number(quickBuyPropertyData?.suggestedShares);
  // For an Entity/Trust account's first order, the admin-configured Suggested Shares value
  // can fall below the $1,000 floor (minButtonValue) — bump the displayed/selectable
  // "Suggested" value up to the floor so the chip isn't stuck disabled and irrelevant.
  const suggestedButtonValue =
    isEntityAccount && isFirstInvestment && rawSuggestedButtonValue < minButtonValue ? minButtonValue : rawSuggestedButtonValue;
  const isMinRangeError = Number(numberOfShare) < Number(minButtonValue);
  const popularShareButtonValue  = Number(quickBuyPropertyData?.popularShares)

  const handleScrollBuy = (e) => {
    if (e.target.scrollTop > 10) setIsScrolledBuy(true);
    else setIsScrolledBuy(false);
  };

  const handleFeatchBankDetail = async (value) => {
    try {
      const userData = await getFundingSources();
      if (!userData.isError) {
        setWalletsData(userData?.data?.wallets.concat(userData?.data?.banks).concat({ id: -1, brandName: 'Add new', sourceType: 'add new' }));
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const handleGetAccountBalances = async () => {
    try {
      const userData = await getAccountBalances();
      if (!userData.isError) {
        setUserBalance(userData?.data);
        const updatedAvailableBalance = userData?.data?.availableBalance?.toString();
        if (walletsData.length > 0) {
          const updatedWalletData = walletsData.map((item) =>
            item.brandName === 'DWOLLA'
              ? { ...item, balance: updatedAvailableBalance, availableBalance: updatedAvailableBalance }
              : item
          );
          setWalletsData(updatedWalletData);
          if (selectedPaymentMethod?.sourceType === 'Wallet') {
            setSelectedPaymentMethod((prev) => ({ ...prev, balance: updatedAvailableBalance, availableBalance: updatedAvailableBalance }));
          }
        }
      }
    } catch (error) {}
  };

  const handleUpdateBanksList = (data) => {
    const updatedBanks = [...(data?.data?.banks ?? null)];
    const updatedWallet = [...(data?.data?.wallets ?? null)];
    setWalletsData([...updatedBanks, ...updatedWallet, { id: -1, brandName: 'Add new', sourceType: 'add new' }]);
    setSelectedPaymentMethod(updatedBanks?.[0]);
  };

  const handleSelectPaymentMethod = (value) => {
    let matchedObject = walletsData?.find((item) => item.id === value);
    // Commented currently as required future to modify
    // let updatedWallet = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Wallet');
    // let updatedBank = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Bank');
    // setWalletsData([matchedObject, ...updatedWallet, ...updatedBank, { id: -1, brandName: 'Add new', sourceType: 'add new' }]);
    setSelectedPaymentMethod(matchedObject);
    setIsEditPayment(false);
  };

  const handleAddBank = (value) => {
    if (!value?.data) return;
    let updatedWallet = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Wallet');
    let updatedBank = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Bank');
    setWalletsData([value.data, ...updatedWallet, ...updatedBank, { id: -1, brandName: 'Add new', sourceType: 'add new' }]);
    setSelectedPaymentMethod(value.data);
    setIsEditPayment(false);
  };

  const openTOSAgreementModal = () => {
    setIsTOSModal(true);
  };

  const onTOSAgreementSuccess = () => {
    setIsTOSModal(false);
    onPinVerifySuccess();
  };

  const onTOSModalClose = () => {
    setIsTOSModal(false);
  };
useEffect(() => {
  if (!isPinVerified) return;
  // isEntityAccount/isFirstInvestment (and therefore minButtonValue) depend on userData
  // fields (accountType/isFirstOrder) that PinModalWithoutButton/PinDrawerWithoutButton
  // dispatch right before calling onPinVerifySuccess synchronously — this effect (rather
  // than onPinVerifySuccess itself) is what guarantees we read the post-dispatch, re-rendered
  // values instead of a stale pre-verification closure.
  let updatedShares;
  if (
    suggestedButtonValue < minButtonValue ||
    suggestedButtonValue > remainingShares ||
    (Number.isFinite(actualSharesRemaining) && suggestedButtonValue > actualSharesRemaining)
  ) {
    updatedShares = minButtonValue;
  } else {
    updatedShares = suggestedButtonValue;
  }
  setNumberOfShare(updatedShares.toString());
  if (bankExists && bankVerified) {
    modalState('StepTwo');
  } else if (!bankExists) {
    modalState(primaryBuy.ADD_BANK);
  } else if (!bankVerified) {
    modalState(primaryBuy.VERIFY_BANK);
  }
  SetIsPinVerified(false);
}, [bankExists, bankVerified, isPinVerified, suggestedButtonValue, minButtonValue, remainingShares, actualSharesRemaining]);

  const onPinVerifySuccess = () => {
    walletsData.length <= 0 && handleFeatchBankDetail();
    handleGetAccountBalances();
    SetIsPinVerified(true);
    setPin('');
    setIsTurmAndCondistion(false);
    setCheckbox1(false);
    setCheckbox2(false);
  };

  const handleVerifyPin = async (isTOSAccepted = false) => {
    if (!isTOSAccepted) {
      modalState('');
      toastNotify(
        'newAgreement',
        <ListingAgreementNotification
          onBtnClick={() => {
            notification.close('newAgreement');
            openTOSAgreementModal();
          }}
        />
      );
    } else {
      onPinVerifySuccess();
    }
  };

  const handleForgotPin = async () => {
    setLoading(true);
    try {
      const resData = await resetLoginPin();
      if (!resData.isError) {
        toastNotify('success', resData?.message);
        modalState();
        setResetPin(true);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePlaceOrder = async (pinSuccessReferralcode) => {
    if (selectedPaymentMethod?.sourceType === 'Wallet') {
      // Wallet: check for sufficient balance, but do NOT call balanceBank API
      if (
        Number(Number(quickBuyPropertyData?.perSharePrice) * Number(numberOfShare)) > Number(userBalance?.cash) || userBalance === 0
      ) {
        const linkText = 'My Account>Account Balances';
        const linkPath = '/account/transactions';
        const openLink = () => {
          window.location.href = linkPath;
        };
        notification.error({
          description: (
            <div>
              <span style={{ cursor: 'pointer' }} onClick={openLink}>
                Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
              </span>
            </div>
          ),
          duration: 5,
        });
        return;
      }
      setLoading(true);
      let data = {
        fundingSourceId: selectedPaymentMethod?.id?.toString(),
        propertyId: quickBuyPropertyData?.id?.toString(),
        noOfShares: parseInt(numberOfShare),
        ...(pinSuccessReferralcode && { referralCode: pinSuccessReferralcode }),
      };
      try {
        const resData = await placeBuyOrder(data);
        if (!resData.isError) {
          setOrderId(resData?.data?.id);
          handleFeatchAgreement(resData?.data?.id);
        }
      } catch (error) {
        setLoading(false);
        const { response } = error;
        toastNotify('error', response?.data?.message);
      }
    } else {
      setLoading(true);
      let data = {
        fundingSourceId: selectedPaymentMethod?.id?.toString(),
        propertyId: quickBuyPropertyData?.id?.toString(),
        noOfShares: parseInt(numberOfShare),
        ...(pinSuccessReferralcode && { referralCode: pinSuccessReferralcode }),
      };
      try {
        // Call balanceBank API first
        const balanceBankData = {
          fundingSourceId: selectedPaymentMethod?.id?.toString(),
          amountToDisburse: totalPurchase.toString(),
        };
        const balanceBankResponse = await balanceBank(balanceBankData);
        // Check if balanceBank API was successful
        if (balanceBankResponse.isError) {
          setLoading(false);
          // Check for specific error message and show custom error
          if (balanceBankResponse?.message === 'INSUFFICIENT_FUND_ERROR') {
            // Close the modal first
            modalState();
            // Show error notification
            const width = window.innerWidth;
            notification.error({
              message: '',
              description: ERROR_BALANCE_BANK_MESSAGE,
              duration: 3,
              placement: width > 1024 ? 'bottomRight' : 'topRight',
            });
            // User is frozen, logout and redirect to login page
            setTimeout(() => {
              localStorage.clear();
              localStorage.setItem('prev_pathname', window.location.pathname);
              window.location.href = '/login';
            }, 5000); // Wait 3 seconds to show the error message before redirecting
          } else {
            toastNotify('error', balanceBankResponse?.message);
          }
          return;
        }
        // Only proceed with placeBuyOrder if balanceBank was successful
        const resData = await placeBuyOrder(data);
        if (!resData.isError) {
          setOrderId(resData?.data?.id);
          handleFeatchAgreement(resData?.data?.id);
        }
      } catch (error) {
        setLoading(false);
        const { response } = error;
        // Check if this is INSUFFICIENT_FUND_ERROR from the catch block
        if (response?.data?.message === 'INSUFFICIENT_FUND_ERROR') {
          // Close the modal first
          modalState();
          // Show error notification
          const width = window.innerWidth;
          notification.error({
            message: '',
            description: ERROR_BALANCE_BANK_MESSAGE,
            duration: 3,
            placement: width > 1024 ? 'bottomRight' : 'topRight',
          });
          // User is frozen, logout and redirect to login page
          setTimeout(() => {
            localStorage.clear();
            localStorage.setItem('prev_pathname', window.location.pathname);
            window.location.href = '/login';
          }, 5000); // Wait 5 seconds to show the error message before redirecting
        } else {
          toastNotify('error', response?.data?.message);
        }
      }
    }
  };

  const handleFeatchAgreement = async (id) => {
    setLoading(true);
    try {
      const resData = await getAgreement(id);
      if (!resData.isError) {
        setAgreementData(resData);
        modalState('StepFour');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAgreeAndContinue = async () => {
    setLoading(true);
    try {
      const resData = await processPlaceOrder(orderId);
      if (!resData.isError) {
        modalState('success');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const featchInitialOfferingData = async () => {
    let response = await dispatch(fetchInitialOfferingListAction({ page: 1, perPage: 10 }));
    if (!response?.payload?.isError) {
      modalState();
    }
  };

  const featchSecondaryOfferingData = async () => {
  await dispatch(fetchSecondaryOfferingListAction({ page: 1, perPage: 9 }));
};

  const handleCancelBuyOrder = async () => {
    await dispatch(cancelBuyOrderAction({ id: orderId }));
  };

  return {
    loading,
    pin,
    walletsData,
    agreementData,
    totalInvestment,
    totalPurchase,
    equity,
    equityWithBonusShares,
    isScrolledBuy,
    numberOfShare,
    resetPin,
    checkbox1,
    checkbox2,
    daysReamaining,
    isTurmAndCondistion,
    isMaxRangeError,
    isMinRangeError,
    sharesRemainingToPurchase: remainingShares,
    selectedPaymentMethod,
    isEditPayment,
    minButtonValue,
    handleVerifyPin,
    handleForgotPin,
    handlePlaceOrder,
    handleScrollBuy,
    handleAgreeAndContinue,
    setNumberOfShare,
    setResetPin,
    setCheckbox1,
    setCheckbox2,
    setPin,
    setIsTurmAndCondistion,
    handleSelectPaymentMethod,
    handleUpdateBanksList,
    setIsEditPayment,
    handleAddBank,
    featchInitialOfferingData,
    handleCancelBuyOrder,
    featchSecondaryOfferingData,
    setLoading,
    isTOSModal,
    onTOSAgreementSuccess,
    onTOSModalClose,
    setSelectedPaymentMethod,
    suggestedButtonValue,
    popularShareButtonValue,
    referralBonusShares,
    remainingShares,
  };
};

export default useQuickBuyOrder;
